import React from 'react';

const Body = (props) => {
  return (
    <>
      <p>{props.comment}</p>
    </>
  );
}

export default Body;